import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, ComponentRef, EventEmitter, Output, QueryList, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { SubtitleBlockComponent } from './subtitle-block/subtitle-block.component';
import { SelectButtonModule } from 'primeng/selectbutton';

@Component({
  standalone: true,
  selector: 'app-title-block',
  templateUrl: './title-block.component.html',
  styleUrls: ['./title-block.component.css'],
  imports: [
    SubtitleBlockComponent,
    ButtonModule,
    DividerModule,
    CommonModule,
    FormsModule,
    SelectButtonModule
  ],
  animations: [
    trigger('fadeInOut', [
      state('void', style({
        opacity: 0,
      })),
      state('*', style({
        opacity: 1
      })),
      transition('void <=> *', animate(200)),
    ]),
  ],
})
export class TitleBlockComponent {

  @ViewChild('firstComponent') firstComponent!: SubtitleBlockComponent

  title = "Agregar título (opcional)"

  lod_title = ""

  show = false

  state = 'void'

options!:any


  ngOnInit() {
    this.state = '*'
  }

  getText(input: string) {
    if(input) this.title = ""
    else this.title = "Agregar título (opcional)"
  }
  deleteTrim(text: string, input: HTMLInputElement) {
    text = text.trim()
    input.value = text
  }

  ngAfterViewInit() {
    this.subtitles.push(this.firstComponent)
  }

  // El emitidor de eventos para borrar el componente
  @Output('delete') delete = new EventEmitter<boolean>()
  deleteView() {
    this.delete.emit(true)
  }

  // Instancia del view container para generar los componentes
  @ViewChild('view', { read: ViewContainerRef }) viewContainer!: ViewContainerRef
  // Generamos el componente e instanciamos su observable para eliminarlo
  generate() {
    const component = this.viewContainer.createComponent(SubtitleBlockComponent)
    this.subtitles.push(component.instance)
    component.instance.delete.asObservable().subscribe( () =>{
      this.subtitles = this.subtitles.filter(item => item != component.instance)
      component.destroy()
    })
  }

  // Instancia de todos los componentes creados
  subtitles: SubtitleBlockComponent[] = []
}
